const sidebar = [
    // Categories
    {
        title: "",
        items: [
            {
                title: "Dashboard",
                path: '/dashboard',
                icon: 'ion ion-speedometer',
                role: 'student'
            },
            {
                title: "Dashboard",
                path: '/dashboard-admin',
                icon: 'ion ion-speedometer',
                role: 'instructor'
            },
            {
                title: 'Profile',
                path: '/student-profile',
                icon: 'zmdi zmdi-account-circle',
                role: 'student'
            },
            {
                title: "Challenges",
                path: '/challenges',
                icon: 'zmdi zmdi-star'
            },
            {
                title: "Instructor Convo",
                path: '/convos',
                icon: 'zmdi zmdi-comments'
            },
            {
                title: "Course Admin",
                path: '/course-admin',
                icon: 'zmdi zmdi-library',
                role: 'instructor'
            },
            {
                title: "My Courses",
                icon: 'zmdi zmdi-library',
                role: 'student',
                items: [
                    {
                        title: "MCAT",
                        path: '#',
                        icon: 'zmdi zmdi-library',
                        // items: [
                        //     {
                        //         title: 'Physics',
                        //         path: '',
                        //     },
                        //     {
                        //         title: 'Chemistry',
                        //         path: '',
                        //     },
                        //     {
                        //         title: 'Math',
                        //         path: '',
                        //     },
                        //     {
                        //         title: 'Behavior',
                        //         path: '',
                        //     },
                        // ]
                    }
                ]
            },
            {
                title: "My Files",
                // path: '',
                icon: 'zmdi zmdi-folder',
                items: [
                    {
                        title: 'Instructor Dashboard',
                        path: '/course-admin',
                    },
                    {
                        title: 'Student Overview ',
                        path: '/student-profile',
                    },
                    {
                        title: 'In-class courses ',
                        path: '/in-person-session',
                    },
                    {
                        title: 'Admin Console',
                        path: '/dashboard-admin',
                    }
                ]
            },
            {
                title: "Inbox",
                path: '/inbox',
                icon: 'zmdi zmdi-email'
            },
            {
                title: "Reminders",
                path: '/reminders',
                icon: 'zmdi zmdi-alarm'
            },
            {
                title: "Settings",
                path: '/settings',
                icon: 'zmdi zmdi-settings'
            },
            {
                title: "Logout",
                path: '/login',
                icon: 'fa fa-power-off'
            }
        ],
    }
];

export default sidebar;


// WEBPACK FOOTER //
// ./src/data/sidebar.js